import Cookies from 'js-cookie';

const LoginKey = 'login-key';

export function getLoginKey() {
  return Cookies.get(LoginKey);
}

export function setLoginKey(token) {
  return Cookies.set(LoginKey, token);
}


export function removeLoginKey() {
  return Cookies.remove(LoginKey);
}